export const prefix = 'administration.courses.new.form.notifications'
